import { render, staticRenderFns } from "./BrandItem.vue?vue&type=template&id=874d2f4c&scoped=true&"
import script from "./BrandItem.vue?vue&type=script&lang=js&"
export * from "./BrandItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandItem.vue?vue&type=style&index=0&id=874d2f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874d2f4c",
  null
  
)

export default component.exports